module.exports = __webpack_public_path__ + "static/icon-target-b93ca6b9e6828ab871233c3aaf135012.jpg";